module.exports = __webpack_public_path__ + "img/edit-rule.285da617.svg";